import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import { PlusCircleIcon } from '@phosphor-icons/react';

import styles from './ClipboardCopy.module.scss';

interface ClipboardCopyProps {
  copyText: string;
  product: MecProduct;
}

const ClipboardCopy = ({ copyText, product }: ClipboardCopyProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const [copiedMessage, setCopiedMessage] = useState('');
  const newCopyText = copyText?.replace(/-/g, '');
  const { t } = useTranslation(['stores', 'common', 'pdp']);

  const copyTextToClipboard = async (text: string) => {
    if ('clipboard' in navigator) {
      return navigator.clipboard.writeText(text);
    }
    return document.execCommand('copy', true, text);
  };

  const handleCopyClick = () => {
    copyTextToClipboard(newCopyText)
      .then(() => {
        setCopiedMessage(t('pdp:product.copyConfirmations'));
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => err);
  };

  return (
    <p
      className={cn(styles.productCode, {
        [styles.productCodeOutOfStock]: !product?.isInStock,
      })}
    >
      {copyText}
      <button
        type="button"
        className={styles.copyButton}
        onClick={handleCopyClick}
        aria-label={t('copy', { defaultValue: 'Copy' })}
      >
        <PlusCircleIcon color="var(--neutrals-700)" />
      </button>
      {isCopied ? (
        <span className={styles.copiedMessage}>{copiedMessage}</span>
      ) : null}
    </p>
  );
};

export default ClipboardCopy;
